

import { useState, useEffect } from 'react'
import Form from "/src/components/form/Form";
import Field from '/src/components/UI/Field/Field';
import TextInput from '/src/components/UI/TextField/TextInput';
import ButtonAction from "/src/components/UI/Button/Button";
import { useForm, useFieldArray } from "react-hook-form";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import ChooseFile from "/src/components/UI/ChooseFile/ChooseFile";
import userService from '../../services/userService';
import companyService from "/src/features/administration/company/services/companyService";
import roleService from '../../../role/services/roleService';
import Dropdown from '/src/components/UI/DropDown/DropDown';
import AutoComplete from "/src/components/UI/AutoComplete/AutoComplete";
import "./UserModalBody.css";
import "./UserModal.css"
import FormData from 'form-data';
import Storage from "/src/utils/storage";
import roleAdmin from '../../../role/assets/role-superadmin.png';
import roleUser from '../../../role/assets/role-partners.png';
import imageChoices from '../../../role/components/RoleForm/roleImages';
import generateKey from '/src/utils/generateKey';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
function UserModalBodyAdmin({ data, title }) {

    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    const currentUser = Storage('local').get('user');
    const { register, handleSubmit, formState: { errors }, getValues, setValue, watch } = useForm({
        mode: "onChange",
        defaultValues: {
            id: data ? data.id : "",
            username: data ? data.username : "",
            email: data ? data.email : "",
            company_id: data ? data.company?.id : "",
            companies: data ? data.companies : "",
            image: data ? data.image : "", // form.statementArray,
            company_role: data ? data.company_role : undefined,
            global_role: data ? data?.roles[0]?.id : undefined
        },
    });

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const { getCompaniesAutocomplete, getCompanies } = companyService;
    const { addUser, updateUser, checkAvaibility } = userService;

    const [listCheckedCompanies, setListCheckedCompanies] = useState([]);

    const { getRolesFilter } = roleService;
    const [roles, setRoles] = useState([]);
    const [companies, setCompanies] = useState([])
    const [rolesCompany, setRolesCompany] = useState([{ value: 'undefined', text: 'Choose Role' }]);

    const [userAvailable, setUserAvailable] = useState({ email: true, username: true });
    const [file, setFile] = useState(data?.image);
    const [loadAnim, setLoading] = useState(null);
    const [dataReady, setDataReady] = useState(false);
    const [showRoleCompanyField, setShowRoleCompanyField] = useState(data ? !data.is_admin : false);

    const onSubmit = async () => {
        var dataToSend = getValues();
        dataToSend.companies_ids = listCheckedCompanies.map(comp => comp.id);

        const formData = new FormData();
        formData.append('username', dataToSend.username)
        formData.append('email', dataToSend.email)
        //formData.append('company_id', dataToSend.company_id)
        formData.append('companies_ids',  JSON.stringify(dataToSend.companies_ids))
        formData.append('company_role', dataToSend.company_role)
        formData.append('global_role', dataToSend.global_role)
        formData.append('image', file)


        let [response, error] = data != null ? await updateUser(data.id, formData) : await addUser(formData)
        if (error !== null) {
            console.log(error);
            return;
        }

        modal.resolve(response)
        onClose();
        return;

    };

    const showImage = (role) => {
        if (role.id === 1) {
            return <img src={roleAdmin} alt="Role Admin" />;
        } else if (role.id === 2) {
            return <img src={roleUser} alt="Role User" />;
        } else {
            const logoChoice = imageChoices.find(choice => choice.value === role.logo);
            if (logoChoice) {
                return <img src={logoChoice.text.props.src} alt={logoChoice.text.props.alt} />;
            } else {
                return <img src={role.avatar} width={24} height={24} alt={role.avatar} />;
            }
        }
    };

    const setUpRoles = (_roles) => {
        const roles = _roles || [];
        roles.sort((a, b) => b.id - a.id);
        return roles.map(role => ({
            value: role.id,
            text:
                <span style={{ maxWidth: "300px", textAlign: 'center' }}>
                    <div className="roles_content_dropdown"> {showImage(role)} {role.id == 1 ? "Super admin" : role.slug}</div>
                </span>
        }))

    }

    const setUpRolesCompany = (_roles) => {
        const rolesCompany = _roles || [];
        const initialOption = { value: 'undefined', text: 'Choose Role' };
        return [
            initialOption,
            ...rolesCompany.map(role => ({
                value: role.id,
                text:
                    <span style={{ maxWidth: "300px", textAlign: 'center' }}>
                        <div className="roles_content_dropdown"> {showImage(role)} {role.slug}</div>
                    </span>
            }))
        ]
    }

    const getRolesByUser = async () => {
        let [response, error] = await getRolesFilter({ company_id: null });
        if (error !== null) {
            console.log(error);
            return;
        }

        setRoles(setUpRoles(response));
    }

    const getRolesByUserInCompany = async () => {
        let companyId = data?.company?.id;
        if (companyId || companyId !== watch('company_id')) {
            companyId = watch('company_id');
        }

        if (companyId) {
            let [response, error] = await getRolesFilter({ company_id: companyId });
            if (error !== null) {
                console.log(error);
                return;
            }
            setRolesCompany(setUpRolesCompany(response));
        }
    };

    const checkValues = async (title, value) => {
        let dataToSend = [];
        dataToSend[title] = value;
        if (value.length == 0) return;
        let [response, error] = await checkAvaibility(dataToSend)
        if (error !== null) {
            console.log(error);
            return;
        }
        let res = userAvailable;
        res[title] = title == "email" && value.match(emailRegex) === null ? false : response.available
        if (data != null && value === data[title]) {
            res[title] = true
        }
        setUserAvailable({ ...res })
    }


    useEffect(() => {
        async function fetchData() {
            await getRolesByUser();
            await getRolesByUserInCompany();
            setDataReady(true);

            if (data && data.company_role) {
                setValue('company_role', data.company_role);
            }
        }
        fetchData();
    }, [watch('company_id')]);

    useEffect(() => {
        if (watch('company_role') !== 1) {
            setValue('company_role', watch('company_role'));
        }
    }, [watch('company_role')]);


    useEffect(() => {
        setShowRoleCompanyField(watch('global_role') !== 1);
    }, [watch('global_role')]);



    useEffect(() => {
        getAllCompanies();
    }, []);

    var defaultChoiceCompany = 'undefined';
    if (data && data.roles && rolesCompany) {
        const roleId = data.roles.find(role => rolesCompany.some(rc => rc.value === role.id));
        if (roleId) {
            defaultChoiceCompany = roleId.id;
        }
    }


    const getAllCompanies = async () => {
        let [response, error] = await getCompanies()
        if (error !== null) {
            console.log(error);
            return;
        }
        setCompanies(response);
        setListCheckedCompanies(data ? data.companies : []);
        return response;
    }

    const checkCompany = (_company) => {
        let result = listCheckedCompanies;
        if (result.filter((company) => { return company.id == _company.id; }).length == 0) { // if dataset is not checked
            result.push(_company);
            setListCheckedCompanies(result)
            document.getElementById(_company.id + "button").style.color = "var(--green)"
            document.getElementById(_company.id + "button").children[0].classList = "fas fa-check-circle"

        }
        else { // if dataset is already checked
            let index = listCheckedCompanies.findIndex(company => { return company.id === _company.id });
            result.splice(index, 1)
            setListCheckedCompanies(result)

            document.getElementById(_company.id + "button").style.color = "var(--main)"
            document.getElementById(_company.id + "button").children[0].classList = "fas fa-plus-circle"
        }
    }

    return (
        <div>
            {dataReady && (
                <Form className="edit-container" onSubmit={handleSubmit(onSubmit)}>
                    <Form.Title>{title}</Form.Title>
                    <Form.Body className="body-editModal-container">
                        <div style={{ marginBottom: '25px', marginTop: '15px', display: "flex", gap: '3rem' }}>
                            <Field label="Global role" listLabelClassName="titles-input" />
                            <div style={{ marginLeft: "5%", marginTop: "2%" }}>
                                <Dropdown name="global_role"  {...register('global_role')} setValue={setValue} choices={roles} defaultChoice={data ? data?.roles[0]?.id : ''} width="240px" ></Dropdown>
                            </div>
                        </div>

                        <div style={{ marginBottom: "15px" }}>
                            <Field label="Username" />
                            <TextInput {...register('username', { required: true, minLength: 1, onChange: (e) => checkValues("username", e.target.value) })} style={{ borderColor: userAvailable.username == false ? 'red' : "" }} className="full-width text_input_user_form" defaultValue={data ? data.username : ""} placeholder="Choose your username" />
                        </div>
                        <div style={{ marginBottom: "15px" }}>
                            <Field label="Email" />
                            <TextInput {...register('email', { required: true, minLength: 1, onChange: (e) => checkValues("email", e.target.value) })} style={{ borderColor: userAvailable.email == false ? 'red' : "" }} className="full-width text_input_user_form" defaultValue={data ? data.email : ""} placeholder="Choose your email" />
                        </div>

                        {currentUser.id != data?.id &&
                            <div className="separator_section_form_user" />
                        }

                        <div className="user_list_companies">
                            {companies.map((company, i) => {
                                let bool = data? data.companies.some(comp => comp.id == company.id) : false;
                                //let bool = listCheckedChannel.includes(_channel.id)
                                return (
                                    <div className="project-block" data-checked="false" data-id={company.id} key={generateKey()} style={{ border: bool ? "2px solid var(--main)" : "" }}>
                                        <div style={{ alignItems: "center", display: "flex" }}>
                                            <i style={{ marginRight: '15px', fontSize: "20px" }}></i>
                                            {company.name}
                                        </div>
                                        <div>
                                            <IconButton id={company.id + "button"} className="main-iconButton add-hover modalButtons-input" icon={bool ? "fas fa-check-circle" : "fas fa-plus-circle"} onClick={(e) => checkCompany(company)} style={{ color: bool ? "var(--green)" : "var(--main)" }} />

                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                        {
                            /*
                        
                                                    <div style={{ marginBottom: "15px" }}>
                                                    <Field label="Organization" />
                                                    <AutoComplete name="company_id" className="full-width text_input_user_form" getItemValue={(name, item) => setValue(name, item.id)} apiCall={getCompaniesAutocomplete} getImageFromItem={(item) => item.logo} placeholder="Choose your organization" value={data ? data.company.name : ''}></AutoComplete>
                                                </div>
                        
                            */
                        }


                        {showRoleCompanyField && (
                            <div style={{ marginBottom: '25px', marginTop: '15px', display: "flex", gap: '2rem' }}>
                                <Field label="Company role" listLabelClassName="titles-input" />
                                {rolesCompany && (
                                    <div style={{ marginLeft: "5%", marginTop: "2%" }}>
                                        <Dropdown name="company_role" setValue={setValue}  {...register('company_role')} choices={rolesCompany} defaultChoice={defaultChoiceCompany} width="235px" ></Dropdown>
                                    </div>
                                )}

                            </div>
                        )}
                        {
                            data?.name && // check if datas exists
                            <div>
                                <Field label="Owner of the user" />
                                <TextInput disabled {...register('owner', { required: true, minLength: 1 })} style={errors.owner ? { borderColor: "red" } : {}} className=" full-width text_input_user_form" defaultValue={data ? data.owner : ""} placeholder="Choose your name" />
                            </div>

                        }
                        <div className="separator_section_form_user" />
                        <div>
                            <Field label="Logo" />
                            <ChooseFile _setFile={setFile} defaultValueImage={data?.picture} accept=".png,.jpg,.jpeg" loadAnim={loadAnim} colorBorder={"inset 0 0 0 1px #dddddd;"}></ChooseFile>
                        </div>
                    </Form.Body>
                    <Form.Buttons>
                        <ButtonAction type="submit" label={data?.id ? "Update" : "Add"} disabled={
                            !(userAvailable.email == true && watch("email").length > 0 && userAvailable.username == true && watch("username").length > 0 && listCheckedCompanies.length > 0
                            )} onSubmit={onSubmit}>

                        </ButtonAction>
                    </Form.Buttons>
                </Form>
            )}
        </div>

    );
}
export default UserModalBodyAdmin;